<div class="div-height">
    <p class="audit-log-p">Audit Log History</p>
    <sh-tabs slot="tabs" class="audit-log-tab">
        <sh-text class="child-tab audit-results">Results({{results}})</sh-text>
        <span class="audit-parent-tab">
            <sh-input-text label='User Name, Asset Name, Asset ID' id="searchText" disabled></sh-input-text>
        </span>
        <sh-dropdown label='Action Type' class="child-tab audit-tab" disabled></sh-dropdown>
        <sh-datepicker label='Date Range' class="child-tab audit-tab" range disabled></sh-datepicker>
    </sh-tabs>
    <sh-page class="page-setting" theme={{theme_color}}>

        <sh-table>
            <!-- a table row can be placed in the 'header' slot of the table -->
            <sh-table-row slot="header">
                <!-- table-heads are used inside header rows -->
                <sh-table-head columns="4" (click)="sort()">Date & Timestamp</sh-table-head>
                <sh-table-head columns="4" unsortable>User Email ID</sh-table-head>
                <sh-table-head columns="4" unsortable>Asset ID</sh-table-head>
                <sh-table-head columns="4" unsortable>Asset Name</sh-table-head>
                <sh-table-head columns="4" unsortable>Action Type</sh-table-head>

                <sh-table-head icon>
                    <sh-icon button icon=""></sh-icon>
                </sh-table-head>
            </sh-table-row>

            <ng-container *ngFor="let auditDetails of auditElements">
                <sh-table-row>
                    <!-- use 'columns', 'col-m' and 'col-s' for defining the span of a cell for diffferent breakpoints -->
                    <sh-table-cell columns="4">{{auditDetails.dateTimeStamp | date: 'long'}}</sh-table-cell>
                    <sh-table-cell columns="4">{{auditDetails.userEmailId}}</sh-table-cell>
                    <sh-table-cell columns="4">{{auditDetails.assetId}}</sh-table-cell>
                    <sh-table-cell columns="4">{{auditDetails.assetName}}</sh-table-cell>
                    <sh-table-cell columns="4">{{auditDetails.action | auditAction }}</sh-table-cell>
                </sh-table-row>
            </ng-container>
            <!-- rows can be repeated using your app's framework templating syntax -->

        </sh-table>
    </sh-page>
    <sh-pagination pages="{{pages}}" current-page="{{currentPage}}"
        (clicked-page-move)="selectPage(currentPage, $event)" (next-page-move)="selectPage(currentPage, $event)"
        (previous-page-move)="selectPage(currentPage, $event)"></sh-pagination>
</div>